/** Defer gates while the user is actively editing; escalate after this much inactivity. */
export const IDLE_ESCALATION_MS = 2 * 60 * 1000;

/**
 * A gate is deferred (sticky bar instead of modal) when a dirty sheet is open AND the user has
 * interacted within the idle window. Once idle past the window, gates escalate to a modal even
 * with the sheet still open (draft autosave protects in-progress work).
 */
export function shouldDeferForBusy(input: {
  isBusy: boolean;
  lastInputAt: number | null;
  now: number;
}): boolean {
  if (!input.isBusy || input.lastInputAt == null) {
    return false;
  }
  return input.now - input.lastInputAt < IDLE_ESCALATION_MS;
}
